import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table';
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import DateTime from 'components/presentation/DateTime';
import Competitor from 'components/presentation/Competitor';
import { Stack } from 'react-bootstrap';
import { getDateTimeFormat, isParalympic } from 'helpers/utils';

export default function TeamRecords({ data }) {

    const { mirs_code, mirs_competition } = useUrlFriendlyToParameters();
    const allRecordsOfDiscipline = data?.team?.discipline?.code ? process.env[(isParalympic(mirs_competition) ? 'REACT_APP_RECORDS_PARAS_' : 'REACT_APP_RECORDS_') + data?.team?.discipline?.code]?.split(',') : [];
    const filteredRecord = data?.team?.records?.filter(rec => {
        return rec?.recordData?.some(rd => rd?.competitor?.code === mirs_code) && allRecordsOfDiscipline?.includes(rec?.recordType?.recordType);
    });

    filteredRecord?.forEach(rec => {
        rec.recordData = rec?.recordData?.filter(record => record?.competitor?.code === mirs_code);
    });

    const columns = useMemo(
        () => [
            ColumnRecord(),
            ColumnEvent(),
            ColumnMark(),
            ColumnDate(),
            ColumnLocation()
        ], []);

    return (
        <>
            {data?.team?.athletes &&
                <>
                    <a name="records"><h2 className="wrsBiosDetail__h2" ><Label data="LabelRecords" /></h2></a>
                    < MirsTable
                        data={filteredRecord}
                        initialSortBy={[{ id: 'event', desc: false }, { id: 'record', desc: false }]}
                        // columns={config.columns}
                        columns={columns}
                        id={`mirs-table-team-records`}
                    />
                </>
            }
        </>
    );
};

function ColumnRecord() {
    return (
        {
            Header: <Label data="HeaderRecord" />,
            className: "text-center",
            accessor: (props) => props?.order,
            headerClassName: "text-center w-5",
            disableSortBy: true,
            id: 'record',
            Cell: (props) => {
                const row = props.cell.row?.original;
                return <div className='fw-bold'>
                    <abbr title={row?.recordType?.description}>{row?.recordType?.recordType}</abbr>
                </div>
            }
        }
    )
}
function ColumnEvent() {
    return (
        {
            Header: <Label data="HeaderEvent" />,
            accessor: props => props?.recordData?.at(0)?.eventUnit?.order,
            className: "text-center",
            headerClassName: "text-center w-10",
            disableSortBy: true,
            id: 'event',
            Cell: (props) => {
                const row = props.cell.row?.original
                return <div>{row?.recordData?.at(0)?.eventUnit?.description}</div>
            }
        }
    )
}
function ColumnMark() {
    return (
        {
            Header: <Label data="HeaderMark" />,
            className: "text-center",
            headerClassName: "text-center w-10",
            disableSortBy: true,
            id: 'mark',
            Cell: (props) => {
                const row = props.cell.row.original
                const result = row?.recordData?.at(0)?.result;

                return <>
                    <div className='fw-bold'>{result}</div>
                    <Stack direction='vertical' className='align-items-start'>
                        {row?.recordData?.at(0)?.competitor?.athletes?.map(athlete => {
                            return <Competitor hidePicture={true} hideNoc={true} {...athlete?.participant} />
                        })}
                    </Stack>
                </>
            }
        }
    )
}
function ColumnDate() {
    return (
        {
            Header: <Label data="HeaderDate" />,
            className: "text-center",
            headerClassName: "text-center w-10",
            disableSortBy: true,
            id: 'date',
            Cell: (props) => {
                const row = props?.cell?.row?.original;
                const formatDate = getDateTimeFormat('DayMonthShortYear');
                return (
                    <DateTime datetime={row?.recordData?.at(0)?.recordDate} format={formatDate} />
                );
            }
        }
    )
}
function ColumnLocation() {
    return (
        {
            Header: <Label data="HeaderLocation" />,
            className: "text-center",
            headerClassName: "text-center w-5",
            disableSortBy: true,
            id: 'location',
            Cell: (props) => {
                const row = props.cell.row.original
                const country = row?.recordData?.at(0)?.country;
                const place = row?.recordData?.at(0)?.place;
                return <div>{place + (country ? ` (${country})` : '')}</div>
            }
        }
    )
}